import { oc } from "@orpc/contract";
import { z } from "zod";

export const ColumnConfigSchema = z.object({
  id: z.string().min(1),
  header: z.string().min(1),
  apiField: z.string(),
  alignRight: z.boolean().optional(),
  sortable: z.boolean().optional(),
  filterable: z.boolean().optional(),
  hidden: z.boolean().optional(),
});

export const GetColumnConfigInputSchema = z.object({
  tableId: z.string().min(1),
});

export const GetColumnConfigResponseSchema = z
  .object({
    columns: z.array(ColumnConfigSchema),
  })
  .nullable();

export const UpsertColumnConfigInputSchema = z.object({
  tableId: z.string().min(1),
  columns: z.array(ColumnConfigSchema),
});

export const UpsertColumnConfigResponseSchema = z.object({
  columns: z.array(ColumnConfigSchema),
});

export const userTableColumnConfigsContracts = {
  get: oc
    .input(GetColumnConfigInputSchema)
    .output(GetColumnConfigResponseSchema)
    .route({ method: "GET" }),
  upsert: oc
    .input(UpsertColumnConfigInputSchema)
    .output(UpsertColumnConfigResponseSchema)
    .route({ method: "POST" }),
} as const;

export type ColumnConfig = z.infer<typeof ColumnConfigSchema>;
export type GetColumnConfigInput = z.infer<typeof GetColumnConfigInputSchema>;
export type GetColumnConfigResponse = z.infer<
  typeof GetColumnConfigResponseSchema
>;
export type UpsertColumnConfigInput = z.infer<
  typeof UpsertColumnConfigInputSchema
>;
export type UpsertColumnConfigResponse = z.infer<
  typeof UpsertColumnConfigResponseSchema
>;
